import { InteractiveButtons } from "../InteractiveButtons";
import { CustomUIRoot } from "./CustomUI.styles";

export const CustomUI = (props) => {
  const { emitUIInteraction, applicationResponse, actionsList, loading } =
    props;

  return (
    <CustomUIRoot id="stream-ui">
      <InteractiveButtons
        applicationResponse={applicationResponse}
        actionsList={actionsList}
        emitUIInteraction={emitUIInteraction}
        loading={loading}
      />
    </CustomUIRoot>
  );
};
